import { useMarkNotificationMutation } from '../notificationsApi';
import { notificationsApiSlice } from '../notificationsApi';
import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from 'notistack';
import { TOAST_ERROR, TOAST_SUCCESS } from '../../../utils/constants';
import i18next from 'i18next';

export const useNotificationsActions = () => {
  const dispatch = useDispatch();
  const [markNotificationTrigger] = useMarkNotificationMutation();

  const markNotification = async ({ ids, method, markAll }) => {
    try {
      const result = await markNotificationTrigger({ ids, method, markAll }).unwrap();
      const status = method === 'markRead' ? 'archived' : 'unarchived';
      enqueueSnackbar(i18next.t('notifications.status', { status }), { variant: TOAST_SUCCESS });
      // Trigger fresh data after marking
      dispatch(notificationsApiSlice.util.invalidateTags(['Notifications', 'UnreadCount']));
      return result;
    } catch (err) {
      const errorMessage = err?.error?.response?.errMsg || 'Failed to mark notification';
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  return {
    markNotification,
  };
};
